import { USERS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const Insurance = {
	getUserInsurances: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${USERS}/${id}/insurances`,
		}),
};
